(function () {
  if (customElements.get('ce-product-media-models') !== undefined) {
    return;
  }

  class ProductMediaModels extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        modelViewer: 'model-viewer',
        json: '[data-product-media-models-json]',
      };

      this.elements = null;

      this.initShopifyXR = this.initShopifyXR.bind(this);
      this.initModelViewerUI = this.initModelViewerUI.bind(this);
    }

    async parsedCallback() {
      this.elements = {
        modelViewers: this.querySelectorAll(this.selectors.modelViewer),
        json: this.querySelector(this.selectors.json),
      };

      await customElements.whenDefined(this.selectors.modelViewer);

      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.initShopifyXR,
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.initModelViewerUI,
        },
      ]);
    }

    initShopifyXR(error) {
      if (error) {
        return;
      }

      if (!window.hasOwnProperty('ShopifyXR')) {
        document.addEventListener('shopify_xr_initialized', () => this.initShopifyXR());
        return;
      }

      const obj = JSON.parse(this.elements.json.textContent);

      ShopifyXR.addModels(obj);
      ShopifyXR.setupXRElements();

      this.elements.json.remove();
    }

    initModelViewerUI(error) {
      if (error) {
        return;
      }

      for (let modelViewer of this.elements.modelViewers) {
        new Shopify.ModelViewerUI(modelViewer);
      }
    }
  }

  customElements.define('ce-product-media-models', ProductMediaModels);
})();
